import React from "react";

import End from "./components/End";
import Header from "./components/Header";
import Fonts from "./components/Fonts";
import Cos from "./components/Cos";
import {HashRouter, Routes, Route} from "react-router-dom";
import Main from "./components/Main";

import Sub1 from "./components/Sub1";
import Sub2 from "./components/Sub2";
import ScrollToTop from "./components/Scroll";

const App = () => {
  return (
    <HashRouter basename={process.env.PUBLIC_URL}>
      <div>
        <Fonts />
        <Header />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/Sub1" element={<Sub1 />} />
          <Route path="/Sub2" element={<Sub2 />} />
        </Routes>
        <End />
      </div>
    </HashRouter>
  );
};

export default App;
